/* The Haaland Code — quick format-selector modal, shown when "Order Now" is
   clicked and the book has multiple formats with no configured default
   variant. Loaded globally (not just on the product page) since "Order Now"
   appears in the nav, hero, mid-page CTAs and mobile purchase bar too. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initFormatModal() {
    const overlay = document.querySelector('[data-hc-format-modal]');
    if (!overlay) return;

    const closeBtns = overlay.querySelectorAll('[data-hc-modal-close]');
    const confirmBtn = overlay.querySelector('[data-hc-modal-confirm]');
    const errorEl = overlay.querySelector('[data-hc-modal-error]');
    let lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      overlay.removeAttribute('hidden');
      window.requestAnimationFrame(function () {
        overlay.setAttribute('data-open', 'true');
      });
      const firstRadio = overlay.querySelector('[data-hc-modal-variant-radio]');
      if (firstRadio) firstRadio.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      overlay.setAttribute('data-open', 'false');
      document.removeEventListener('keydown', onKeydown);
      window.setTimeout(function () {
        overlay.setAttribute('hidden', '');
      }, 250);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = overlay.querySelectorAll('button, input, a[href]');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    document.addEventListener('hc:open-format-modal', open);
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) close();
    });

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        const selected = overlay.querySelector('[data-hc-modal-variant-radio]:checked');
        if (!selected) {
          if (errorEl) errorEl.textContent = 'Choose a format to continue.';
          return;
        }
        if (window.HC && window.HC.addToCartAndRedirect) {
          window.HC.addToCartAndRedirect(selected.value, 1, {
            button: confirmBtn,
            errorEl: errorEl,
            eventName: 'product_order_now_click',
          }).then(close);
        }
      });
    }
  }

  ready(initFormatModal);
})();
